import { css } from '@emotion/react';
import { DesignToken, RadiusToken, SpacingToken } from '@livechat/design-system-react-components';
import { MEDIA_MIN_SM } from '_assets/css/breakpoints';

export const topMenuContainerStyles = (isMenuVisible: boolean) => css`
  display: flex;
  min-width: 268px;
  min-width: fit-content;
  justify-content: space-between;
  align-items: center;
  margin-top: var(${SpacingToken.Spacing2});
  padding: var(${SpacingToken.Spacing2}) var(${SpacingToken.Spacing4});
  border-radius: var(${RadiusToken.Radius3});

  &:hover {
    background-color: var(${DesignToken.SurfaceSecondaryDefault});
    cursor: pointer;
  }

  ${isMenuVisible && `background-color: var(${DesignToken.SurfaceSecondaryDefault});`}

  ${MEDIA_MIN_SM} {
    max-width: 512px;
  }
`;
